import { getConceptAmountsPayload } from '@/returns/helpers/helpers'

export const transformRequestModifyAmounts = ({ returnId, concepts, refundMethod, note }) => {
  return {
    returnId,
    payload: {
      refund_method: refundMethod,
      note,
      ...getConceptAmountsPayload(concepts),
    },
  }
}
